import _extends from "@babel/runtime/helpers/esm/extends";
/** @jsx jsx */

import { jsx } from 'theme-ui';
import * as styles from './styles';
import { Search } from '../Icons';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NavSearch = function NavSearch(props) {
  return jsx("div", {
    sx: styles.wrapper,
    "data-testid": "nav-search"
  }, jsx(Search, {
    size: 20,
    sx: styles.icon
  }), jsx("input", _extends({}, props, {
    sx: styles.input
  })));
};

if (typeof NavSearch !== 'undefined' && NavSearch && NavSearch === Object(NavSearch) && Object.isExtensible(NavSearch) && !NavSearch.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavSearch, '__filemeta', {
    configurable: true,
    value: {
      name: "NavSearch",
      filename: "node_modules/gatsby-theme-docz/src/components/NavSearch/index.js"
    }
  });
}